import { Injectable } from '@angular/core';
import { Router } from '@angular/router';


import { ReportsRouteTypeEnum, reportsRouteUrlPaths } from '../../Reports/enums/reports-route-type.enum';


@Injectable()
export class MonitorReportsNavigationService {
    private readonly monitoringRootPath: string = 'Monitoring';

    constructor(
        private router: Router
    ) {}

    /**
     * Routes to a monitoring section
    */
    private goto(path: (string | number)[], replaceURL: boolean = false, queryParams: any = {}): void {
        this.router.navigate(
            [
                this.monitoringRootPath,
                ...path
            ],
            // Optionally replace the previous URL in the browser history
            {
                replaceUrl: replaceURL,
                queryParams: queryParams
            }
        );
    }

    /**
     * Updates the route to send the user to the briefings hype page
     */
    public gotoBriefings(): void {
        this.goto(['briefings']);
    }

    /**
     * Updates the route to send the user to the alerts hype page
     */
    public gotoAlerts(): void {
        this.goto(['alerts']);
    }

    /**
     * Updates the route to send the user to the search page
     */
    public gotoTopics(): void {
        this.goto(['topics']);
    }

    /**
     * Updates the route to send the user to the search page
     */
    public gotoSearch(copyTopicId?: number): void {
        if (copyTopicId) {
            this.goto(['search'], undefined, { copy: copyTopicId });
        } else {
            this.goto(['search']);
        }
    }

    /**
     * Updates the route to send the user to the subscriptions feature
    */
    public gotoMediaSubscriptions(): void {
        this.goto(['subscriptions']);
    }

    /**
     * Updates the route to send the user to the saved mentions page
     */
    public gotoSavedCoverageHype(): void {
        this.goto(['mentions']);
    }

    public goToSharedReports(): void {
        this.router.navigate(
            [
                reportsRouteUrlPaths.baseUrl,
                ...reportsRouteUrlPaths[ReportsRouteTypeEnum.reportSharedReports]
            ]
        );
    }

    public gotoReports(options?: any): void {
        const navigationExtras = options?.queryParams
            ? { queryParams: options.queryParams }
            : undefined;

        this.router.navigate(
            [
                reportsRouteUrlPaths.baseUrl,
                ...reportsRouteUrlPaths[ReportsRouteTypeEnum.reportsHype]
            ],
            navigationExtras
        );
    }

    /**
     * Updates the route to send the user to an individual report
     */
    public gotoReport(id?: string | number, quickReport: boolean = false, cloneId?: number): void {
        const path = [
            reportsRouteUrlPaths.baseUrl,
            ...reportsRouteUrlPaths[ReportsRouteTypeEnum.report]
        ];
        const queryParams = {};

        if (id) {
            path.push('' + id);
        }
        if (quickReport) {
            queryParams['quickReport'] = true;
        }
        if (cloneId >= 0) {
            queryParams['cloneId'] = cloneId;
        }

        this.router.navigate(path,
            {
                replaceUrl: false,
                queryParams: queryParams
            }
        );
    }

}
